import { useEffect, useState } from 'react';
import { metadata } from 'lib_ui-services';

/**
 * @typedef {{_meta:{ id: string, title: string, dataType?: string, prettyName?: string}, [key:string]:LegacyTypeDef }} LegacyTypeDef
 * @typedef {{_meta:{ id:string, title:string, dataType?:string, propertyName?:string}, [key:string]:TypeDef}} TypeDef
 * @typedef {{[key:string]:TypeDef | LegacyTypeDef}} DataModel
 */

export const _private = {
    getDictionary: metadata.getDictionary
};
/**
 *
 * @param {string} namespace
 * @param {string} relation
 * @returns { object | DataModel}
 */
export default function useDataModel(namespace, relation) {
    const [dataModel, setDataModel] = useState({});
    useEffect(() => {
        let allowStateUpdate = true;
        async function doAsync() {
            const dd = await _private.getDictionary();
            if (allowStateUpdate && dd != null) {
                setDataModel(dd?.[namespace]?.[relation] || {});
            }
        }
        doAsync();
        return () => (allowStateUpdate = false);
    }, [namespace, relation, setDataModel]);
    return dataModel;
}
